var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"ml-1",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAssinaturaAdtivoContrato()}}},[_c('span',[_c('i',{staticClass:"fa fa-random mr-2"}),_vm._v(" Enviar Aditivo UABS ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }